'use client'
import React from 'react'
import type { ExternalResourceArchiveBlock as ExternalResourceArchiveType } from '@/payload-types'
import RichText from '@/ui/components/RichText'
import { Title, HeadingTag } from '@/ui/components/Title'
import { Card } from '@/ui/components/Card'
import { CardType } from '@/ui/components/Card/types'

interface Props extends ExternalResourceArchiveType {
  locale: string
  fixedTitleStyle?: HeadingTag
}

export const ExternalResourceArchive: React.FC<Props> = ({
  title,
  titleHierarchy,
  fixedTitleStyle,
  text,
  externalResourceCards,
}) => {
  return (
    <div className="w-full">
      {title && (
        <Title hierarchy={titleHierarchy} fixedStyle={fixedTitleStyle} className="lg:mb-8 mb-5">
          {title}
        </Title>
      )}
      {text && <RichText data={text} className="mb-10" enableProse={false} enableGutter={false} />}

      <div className="grid lg:grid-cols-2 grid-cols-1 gap-2">
        {externalResourceCards?.map((resource, index) => (
          <Card
            key={resource.id || index}
            type={CardType.Standard}
            href={resource.url || '#'}
            title={resource.title || ''}
            description={resource.excerpt || undefined}
            appearance="filled"
            isExternal={true}
            target="_blank"
          />
        ))}
      </div>
    </div>
  )
}
